<template>
  <b-modal
    id="AuthSessionExpireModal"
    v-model="showModal"
    title="Please sign in again"
    size="md"
    centered
    no-close-on-backdrop
    no-close-on-esc
    static
    @close.prevent="reload"
  >
    <p class="my-2">You were signed out of your account. Please press 'Reload' to sign in again.</p>

    <template #modal-footer>
      <b-button variant="primary" class="btn__reload" @click="reload">
        <b-spinner v-if="isReloading" label="Reloading..." variant="secondary" small />

        <span v-else>Reload</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { useAuth } from '@/composables/useAuth';
import Auth from '@/models/Auth';

const { logout } = useAuth();

export default {
  data() {
    return {
      showModal: false,
      isReloading: false
    };
  },

  computed: {
    isAuthTokenInvalid() {
      return Auth.isTokenInvalid();
    }
  },

  watch: {
    isAuthTokenInvalid: {
      immediate: true,
      handler: 'onIsAuthTokenInvalidChange'
    }
  },

  methods: {
    onIsAuthTokenInvalidChange(isTokenInvalid) {
      this.showModal = isTokenInvalid;
    },

    reload() {
      this.isReloading = true;

      const redirectRoute = this.$router.resolve({
        name: 'SignIn',
        query: {
          previousPath: this.$route.fullPath
        }
      });

      logout({
        url: redirectRoute.href
      });
    }
  }
};
</script>
